import React from 'react';
import HorizontalTabs from 'sushiweb/HorizontalTabs';
import { ConfigTabs, TabsSectionWrapper, tabStyles } from '../constants';

const Tabs = ({ selectedEntityType, handleTabClick }) => {
  return (
    <TabsSectionWrapper>
      <HorizontalTabs alignLinks={'left'}>
        {ConfigTabs?.map((tab) => {
          if (!tab) return null;
          return (
            <React.Fragment key={tab.key}>
              <HorizontalTabs.Link
                id={tab.key}
                style={{
                  cursor: 'pointer',
                  textAlign: 'center',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '200px',
                }}
                active={selectedEntityType === tab.key}
                onClick={() => handleTabClick(tab.key)}
                css={tabStyles}
              >
                <div
                  className={`tw-font-medium  ${
                    selectedEntityType === tab.key
                      ? 'tw-text-base-green tw-text-[1.4rem]'
                      : ''
                  } `}
                >
                  {tab.title}
                </div>
              </HorizontalTabs.Link>
            </React.Fragment>
          );
        })}
      </HorizontalTabs>
    </TabsSectionWrapper>
  );
};

export default Tabs;
